export default __webpack_public_path__ + "static/media/66.8cc0bed3.jpeg";